import React from "react";

import { ChargePaymentStatus, ChargeStatusPill } from "../ChargeStatusPill";

export type OrderStatus =
  | "CANCELED"
  | "DRAFT"
  | "EMPTY"
  | "FULLY_PAID"
  | "FULLY_REFUNDED"
  | "OPEN"
  | "PARTIALLY_PAID"
  | "PARTIALLY_REFUNDED";

export const OrderStatusPill = ({ status }: { status: OrderStatus }) => {
  return <ChargeStatusPill status={getChargeStatusFromOrderStatus(status)} />;
};

export const getChargeStatusFromOrderStatus = (
  status: OrderStatus
): ChargePaymentStatus => {
  switch (status) {
    case "EMPTY":
      return "INCOMPLETE";
    case "DRAFT":
    case "OPEN":
      return "UNPAID";
    case "FULLY_PAID":
      return "PAID";
    case "CANCELED":
      return "CANCELED";
    case "FULLY_REFUNDED":
      return "FULLY_REFUNDED";
    case "PARTIALLY_PAID":
      return "PARTIALLY_PAID";
    case "PARTIALLY_REFUNDED":
      return "PARTIALLY_REFUNDED";
  }
};

export const getOrderStatusLabel = (status: OrderStatus) =>
  getChargeStatusFromOrderStatus(status).replace("_", " ");
